import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import OwlCarousel from "react-owl-carousel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Stack from "@mui/material/Stack";
import eng from "../../../assets/Images/Outterpage/eng.webp";
import jap from "../../../assets/Images/Outterpage/jap.webp";
import cardimg from "../../../assets/Images/Outterpage/card-1.webp";
import sec4 from "../../../assets/Images/Outterpage/sec-4-img.webp";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import cpbanner from "../../../assets/Images/Outterpage/cpy-trading-banner.webp";
import sec2cp from "../../../assets/Images/Outterpage/cp-trade-sec-2.webp";
import star from "../../../assets/Images/Outterpage/cp-star.webp";
import imgcrn from "../../../assets/Images/Outterpage/img-crn.webp";
import { useScroll, useTransform, motion, useInView } from "framer-motion";
import aboutbanner from "../../../assets/Images/Outterpage/about-banner.webp";
import sec2Aboutus from "../../../assets/Images/Outterpage/abt-sec-2.webp";
import "../outterpages.css";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
  "&:nth-of-type(odd)": {
    background:
      "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
  },
  // Hide the last border of the table
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const testimonials = [
  {
    name: "Sherly",
    position: "CEO",
    text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
  },
  {
    name: "Carlos",
    position: "Product Manager",
    text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
  },

];

const options = {
  margin: 50,
  items: 1,
  autoplay: true,
  autoplayTimeout: 6000,
  dots: false, // Hide default dots
  loop: true,
  smartSpeed: 800,
  nav: true, // We will use custom navigation
  responsive: {
    0: {
      dots: true,
      nav: false,
    },
    768: {
      dots: false,
      nav: true,
    },
  },
};

const marketData = [
  { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];

const tableData = [
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
];
const accordianData = [
  {
    question: "How Does Copy Trading Work?",
    answer:
      "Copy trading enables users to automatically replicate trades made by experienced traders. When a selected trader executes a trade, it is mirrored in the follower's account, reflecting the same actions in real-time.",
    panel: "panel1",
  },
  {
    question: "Is Copy Trading Suitable for Beginners?",
    answer:
      "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",
    panel: "panel2",
  },
];
const cardset = [
  {
    head: "Lightning Fast Execution",
    para: "We offer ultra-fast execution speeds that ensure your trades are executed without delay, allowing you to take advantage of market opportunities.",
  },
  {
    head: "Top-notch Support",
    para: "Our team of dedicated support professionals are available 24/5 to assist you with any queries or concerns you may have.",
  },
  {
    head: "50+ Popular pairs",
    para: "We offer a wide range of currency pairs to trade, including all the popular pairs. Provides our clients with the flexibility to trade.",
  },
  {
    head: "Optimized Performance",
    para: "We regularly update our platform to incorporate the latest technologies and features to enhance your trading experience.",
  },
  {
    head: "Best Offers Available",
    para: "Our offers are designed to provide maximum value and benefits to our clients, including deposit bonuses and other exciting promotions.",
  },
  {
    head: "Regular Updates",
    para: "We offer regular updates on market trends, economic events, and trading opportunities to ensure our clients are well-informed.",
  },
];
const AboutUs = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const md900 = useMediaQuery(theme.breakpoints.up("900"));
  const lg1400 = useMediaQuery(theme.breakpoints.up("1400"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const [expanded, setExpanded] = React.useState("panel1");
  const lg1200 = useMediaQuery(theme.breakpoints.up("1200"));

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const keyMap = { a: "cd1", b: "cd2", c: "cd3", d: "cd4" };

  // Create separate refs
  const refA = useRef(null);
  const refB = useRef(null);
  const refC = useRef(null);
  const refD = useRef(null);

  // Use useInView for each
  const isInViewA = useInView(refA, { once: true });
  const isInViewB = useInView(refB, { once: true });
  const isInViewC = useInView(refC, { once: true });
  const isInViewD = useInView(refD, { once: true });

  return (
    <div className="OutterPage">
      <Header />
      <div className="bg-outer">
        <section className="banner outter-banner aboutus">
          <div className="contain-width">
            <Grid container sx={{ alignItems: "flexStart" }}>
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                sx={{ placeContent: "center" }}
              >
                <div
                  className="banner-left "
                  style={{
                    height: xl ? "500px" : "auto",
                    placeContent: "center",
                  }}
                >
                  <p>About us</p>
                  <h1 className="mb-30 mt-10">
                    Empowering Traders Worldwide - Learn and Trade with 
                    <span>Finowiz</span>
                  </h1>
                  <p>
                    We’re proud of our status as a global online trading
                    company, and we won’t rest until we can give every one of
                    our traders the ultimate trading experience.
                  </p>
                  {/* <div
                   className="display-1 btn flex-wrap "
                   style={{ marginBottom: matches ? "40px" : "20px" }}
                 >
                   <Link to="/open-new-account" className="bg-btn">
                     Get Started
                   </Link>
                 </div> */}
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <div className="text-center ">
                  <img width="90%" src={aboutbanner} />
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
        <section className="trade-easy sec-3 cp-2 aboutus">
          <div className="contain-width">
            <Grid
              container
              spacing={2}
              sx={{ flexDirection: !md900 && "column-reverse" }}
            >
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                sx={{ placeContent: !lg1400 && "center" }}
              >
                <div>
                  <img width="90%" src={sec2Aboutus} />
                </div>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <div className="heading">
                  <p>Finowiz Advantage</p>
                  <h2>
                    Trade with <span>Finowiz</span> for Competitive Advantages
                  </h2>
                  {/* <p>
                                        Copy the trades of top traders, access sophisticated strategies, and enhance your trading experience. Leverage the expertise of seasoned professionals and replicate their successful tactics with Finowiz's Copy Trading.
                                    </p> */}
                </div>
                <div className="display-1 advtage mt-20">
                  <div>
                    <img width="70%" src={cardimg} />
                  </div>
                  <div>
                    <p>
                      <span className="grd">Superior trade executions</span>
                    </p>
                    <p>
                      Your trades will be executed with exceptional speed,
                      accuracy, and efficiency.
                    </p>
                  </div>
                </div>
                <div className="display-1 advtage mt-20">
                  <div>
                    <img width="70%" src={cardimg} />
                  </div>
                  <div>
                    <p>
                      <span className="grd">
                        Professional guidance & support
                      </span>
                    </p>
                    <p>
                      Experts is always available to provide you with the
                      guidance and support you need.
                    </p>
                  </div>
                </div>
                <div className="display-1 advtage mt-20">
                  <div>
                    <img width="70%" src={cardimg} />
                  </div>
                  <div>
                    <p>
                      <span className="grd">Best in class service</span>
                    </p>
                    <p>
                      Our unparalleled services offer best trading environment
                      and ease to transact
                    </p>
                  </div>
                </div>
               
              </Grid>
            </Grid>
          </div>
        </section>
      </div>
      <section className="trade-easy sec-3 aboutus ">
        <div className="contain-width">
          <div className="heading">
            <p>Our Services</p>
            <h2>
              What <span>We Offer</span>
            </h2>
            <p>
              Enjoy exclusive copy trading features with Finowiz for a superior
              trading experience.
            </p>
          </div>
          <Grid container spacing={5} className="mt-50">
            {cardset.map((item) => (
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                className="why-choose-card mt-10"
                sx={{ alignItems: !md900 && "center" }}
              >
                <div>
                  <img src={cardimg} />
                </div>
                <p className="mt-10 head">
                  <span className="grd">{item.head}</span>
                </p>
                <p className="mt-10">{item.para}</p>
              </Grid>
            ))}
          </Grid>
        </div>
      </section>

      <section class="cta-sec2 out-cta">
        <div className="contain-width">
          <Grid container spacing={8}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <label>Interested in Trading?</label>
              <h2>Start your profitable journey with us</h2>
              <Link to="#" className="brd-btn">
                Get Started
              </Link>
            </Grid>
          </Grid>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
